import React, { Component } from 'react';
import classes from './CategoryTitlesSelector.module.css';
import { ideas } from 'shared/siteContent';
import { categoryImages } from 'shared/utility';

class CategoryTitlesSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ideaListHeight: '100%',
    };
    this.titleIdeasContainer = React.createRef();
  }

  setIdeaListContainerHeight = (offset) => {
    const ideasListHeight = this.props.shortWindow === true ? 630 - offset : 708 - offset;
    this.setState({ ideaListHeight: ideasListHeight });
  };

  componentDidMount() {
    this.setIdeaListContainerHeight(this.titleIdeasContainer.current.offsetTop);
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setIdeaListContainerHeight(this.titleIdeasContainer.current.offsetTop);
    }
  }

  render = () => {
    let titleIdeas = null;
    let categoryDescription = '';

    if (this.props.contentCategory) {
      const categoryDetails = ideas.find((obj) => obj.name === this.props.contentCategory);
      titleIdeas = categoryDetails.ideas.map((idea, i) => {
        return (
          <div className={classes.TitleIdea} key={i} onClick={() => this.props.clicked(idea.title, idea.tags)}>
            {idea.title}
          </div>
        );
      });
      categoryDescription = <p className={classes.CategoryBlurb}> {categoryDetails.description}</p>;
    }

    let categoryImage = null;
    if (this.props.contentCategory) {
      categoryImage = categoryImages.find((category) => category.name === this.props.contentCategory);
    }

    return (
      <div>
        <div className={classes.Header}>
          {categoryImage !== null ? <categoryImage.image /> : null}
          {categoryDescription}
        </div>
        <div ref={this.titleIdeasContainer} style={{ height: `${this.state.ideaListHeight}px` }} className={classes.TitleIdeasContainer}>
          {titleIdeas}
        </div>
      </div>
    );
  };
}

export default CategoryTitlesSelector;
